import { HappyRedPacketContract } from '@/contract/func/redPacket'
import { TokenContract } from '@/contract/func/token'
import { markRaw } from 'vue'
import { Module } from 'vuex'

interface State {
  contract: HappyRedPacketContract | null
}

export const store = {
  namespaced: true,
  state: () => ({
    contract: null
  }),
  getters: {},
  mutations: {
    INIT_CONTRACT (state, contract: HappyRedPacketContract) {
      state.contract = markRaw(contract)
    }
  },
  actions: {
    init ({ commit, dispatch }, payload: {
      address: string
      rpc: string
    }) {
      const contract = new HappyRedPacketContract(payload.address, payload.rpc)

      commit('INIT_CONTRACT', markRaw(contract))
    }
  }
} as Module<State, any>
